import { render, staticRenderFns } from "./LangSwitch.vue?vue&type=template&id=3388a1ab&"
import script from "./LangSwitch.vue?vue&type=script&lang=js&"
export * from "./LangSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnDropdown,QList,QItem,QItemSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnDropdown,QList,QItem,QItemSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
